module.exports = __webpack_public_path__ + "static/media/Domanin.85a2b121.md";